<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/daily/schedule/index' }">日程</el-breadcrumb-item>
      <el-breadcrumb-item>当日</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="160px">
          <el-form-item label="日程项" prop="content">
            <el-col :span="12">
              <el-input :autosize="{ minRows: 10, maxRows: 24}" @keyup.enter.native="lineSplit"" type="textarea" v-model="form.content" placeholder="请输入当日所有日程"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        id: '',
        content: '',
      },
      rules: {
        content: [
          {  required: true, message: '请输入当日所有日程', trigger: 'blur' },
          { min: 1, max: 2000, message: '内容长度在1到2000个字符', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    loadSchedule() {
      this.$ajax({
        url: "/daily/schedule/day",
        type:"GET",
      }).then(res => {
        this.form = {
          content: res.data,
        }
      });
    },
    lineSplit() {
      
    },
    save() {
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if(!valid) {
          return false;
        }

        // 开始处理loading.
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          type: 'POST',
          url: '/daily/schedule/multi',
          data: form,
        }).then((res) => {
          loading.close()
          if(res.code != 200) {
            return this.$util.msg(res.msg, "error");
          }
          
          this.$util.msg(res.msg, "success");

          setTimeout(() => {
            this.$router.push({ path: "/daily/schedule/index" });
          });
        })
      });

      return false;
    }
  },
  mounted() {
    this.loadSchedule()
  }
};
</script>
<style>
</style>